<script lang="ts">
	import { Accordion } from 'bits-ui';
	import type { Snippet } from 'svelte';

	let { title, children, value }: { title: string; children: Snippet; value?: string } = $props();
</script>

<Accordion.Item class="flex flex-col gap-4" {value} id={value}>
	<Accordion.Header>
		<Accordion.Trigger class="w-full text-left font-bold lg:text-lg">{title}</Accordion.Trigger>
	</Accordion.Header>
	<Accordion.Content>
		{@render children()}
	</Accordion.Content>
</Accordion.Item>
